<template>
  <div class="menu-container">
    <div class="nav-containter">
      <el-button
        v-for="(item, index) in menus.filter((v) => v.hidden !== true)"
        :key="index"
        :class="`menu-label menu-label-${item.diagnosed}-${
          item.after
        } menu-label-${currentKey === item.key ? 'selected' : 'no'}`"
        @click="select(item.key)"
        v-text="$t(`langcfg.${item.label}`)"
      />
    </div>
    <div class="controls-container">
      <slot name="controls" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    menuItems: {
      type: Array,
      default: () => {
        return [];
      }
    },
    currentKey: {
      type: String,
      default: ""
    },
    isReCaputreVisible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    menus() {
      return this.menuItems.filter((item) => {
        return this.isReCaputreVisible ? item.visibleInCapture : true;
      });
    }
  },
  watch: {
    menuItems: {
      immediate: true,
      handler(val) {
        let keys = val.filter((v) => !v.hidden).map((v) => v.key);
        if (!keys.includes(this.currentKey)) {
          this.select(keys[0]);
        }
      }
    }
  },
  methods: {
    select(key) {
      this.$emit("select", key);
    }
  }
};
</script>
<style lang="less" scoped>
.menu-container {
  display: flex;
  align-items: center;
  height: 100%;
}

.nav-containter {
  display: flex;
  align-items: center;
  flex: 1;
  overflow-x: auto;
  height: 100%;
}

.controls-container {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  & > * {
    margin-left: 20px;
  }
  & > *:last-child {
    margin-right: 20px;
  }
}

.menu-label {
  color: white;
  font-size: @header-fs+-2px;
  padding-left: 18px;
  height: 100%;
  text-align: left;
  flex-grow: 0;
  flex-shrink: 0;
}
// .menu-label:hover {
//   color: @btn-hover-color;
// }
.menu-label-Y-after::after {
  content: " ●";
  color: white;
}
.menu-label-N-after::after {
  content: " ○";
  color: white;
}
.menu-label-selected {
  color: @blue-selected-color;
}
.menu-label-selected-after::after {
  color: @blue-selected-color;
}
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 15px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 15px;
}
// ::-webkit-scrollbar-thumb {
//   border-radius: 0px;
//   box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
//   background-color: rgba(255, 255, 255, 0.4);
// }
// ::-webkit-scrollbar-track {
//   box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
//   border-radius: 15px;
//   background: rgba(100, 100, 100, 0.8);
// }

// 白底滚动条
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background-color: rgba(0, 0, 0, 0.4);
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0px;
  background: rgba(255, 255, 255, 1);
}
// /* 箭头向右 */
::-webkit-scrollbar-button:horizontal:start:single-button {
  // content: '';
  display: block;
  width: 15px;
  height: 15px;
  background: white url("../../../assets/img/caret-left.png") no-repeat 0 0;
  background-size: 16px 16px;
  background-position: 0px -1px;
}
/* 箭头向左 */
::-webkit-scrollbar-button:horizontal:end:single-button {
  display: block;
  width: 15px;
  height: 15px;
  background: white url("../../../assets/img/caret-right.png") no-repeat 0 0;
  background-size: 15px 15px;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/basic/Menu.vue